const routes = [
  {
    path: "/usuarios",
    name: "usuario-list",
    meta: {
      allowedPermissions: ["usuario_list"],
    },
    component: () => import("@/views/Usuario/ListView.vue"),
  },
  {
    path: "/usuarios/novo",
    name: "usuario-add",
    meta: {
      allowedPermissions: ["usuario_insert"],
    },
    component: () => import("@/views/Usuario/AddView.vue"),
  },
  {
    path: "/usuarios/:id/editar",
    name: "usuario-edit",
    meta: {
      allowedPermissions: ["usuario_update"],
    },
    component: () => import("@/views/Usuario/EditView.vue"),
  },
  {
    path: "/usuarios/:id/perfil",
    name: "usuario-perfil",
    meta: {
      allowedPermissions: ["usuario_perfil_update"],
    },
    component: () => import("@/views/Usuario/ProfileView.vue"),
  },
];

export default routes;
